import React from "react";

const GetDirectionToShop = ({ offer }) => {
	const latitude = offer?.location?.lat;
	const longitude = offer?.location?.lng;

	const getDirections = () => {
		if (latitude === undefined || longitude === undefined) {
			alert("Store location is not available");
			return;
		}

		const mapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}`;

		window.open(mapsUrl, "_blank");
	};

	const mapSrc = `https://maps.google.com/maps?q=${latitude},${longitude}&z=15&output=embed`;

	return (
		<div className="p-3">
			<div className="shop-box description-color">
				<div className="d-flex">
					<div className="shop-name-details">
						<h6 className="mb-0">Shop name: </h6>{" "}
					</div>
					<div className="text-left">
						<h6 className="pl-2 mb-2">
							{offer.shopName?.charAt(0).toUpperCase() +
								offer.shopName?.slice(1)}
						</h6>
					</div>
				</div>

				<div className="d-flex ">
					<div className="shop-name-details ">
						<h6>Shop contact: </h6>{" "}
					</div>
					<div className="text-left">
						<h6 className="pl-2">{offer.shopPhone}</h6>
					</div>
				</div>

				<div className="d-flex">
					<div className="shop-address-details">
						<h6>Shop address: <span className="pl-3">Below Map</span> <i style={{color: "green", fontSize: "20px"}} className="fa-solid fa-arrow-down pl-2"></i> </h6>{" "}
					</div>
				</div>
			</div>

			<iframe
				title="map"
				width="100%"
				height="200"
				className="map"
				src={mapSrc}
				loading="lazy"
				style={{
					border: 0,
					display: "block",
				}}
			/>

			<div>
				<button
					className="btn btn-primary w-100 mt-3"
					onClick={getDirections}
				>
					<i className="fas fa-location-arrow mr-2"></i>
					Get directions to shop
				</button>
			</div>
		</div>
	);
};

export default GetDirectionToShop;